import { theme } from 'gatsby-theme-fela';

import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { AnalyticsEvent, getPlausibleClassName } from 'utils/analytics';

import { content } from './content';

import { LocalizedLink } from '../../LocalizedLink';
import { DynamicContainer } from '../../Layout/DynamicContainer';
import { ContainerType } from '../../Layout/constants';

const { mainNavigation, moreLinks } = content;

// active className for links is not safe, hence we have to use style
const activeStyle = {
    color: theme.colors.fuchsia,
};

const MainNavigation = ({ styles, rules }) => (
    <div className={styles.container}>
        <ul className={styles.list}>
            {mainNavigation.map(link => (
                <li
                    key={link.id}
                    className={getPlausibleClassName(styles.bigLinkItem, AnalyticsEvent.BURGER_MENU_CLICK, {
                        click_text: link.id,
                        click_url: link.href,
                    })}
                >
                    <LocalizedLink
                        eventId={link.id.replace('mainNavigation', 'burgerNavigation')}
                        to={link.href}
                        activeStyle={activeStyle}
                        className={styles.bigLink}
                    >
                        <FormattedMessage id={link.id} />
                    </LocalizedLink>
                </li>
            ))}
        </ul>
        <p className={styles.sectionTitle}>
            <FormattedMessage id="mainNavigation.moreLinks.title" />
        </p>
        <ul className={styles.listMoreLinks}>
            <DynamicContainer columns={6} type={ContainerType.GRID} extend={{ container: rules.moreLinksInner }}>
                {moreLinks.map(link => (
                    <li
                        key={link.id}
                        className={getPlausibleClassName(styles.linkItem, AnalyticsEvent.BURGER_MENU_CLICK, {
                            click_text: link.id,
                            click_url: link.href,
                        })}
                    >
                        <LocalizedLink
                            activeStyle={activeStyle}
                            eventId={link.id.replace('mainNavigation', 'burgerNavigation')}
                            to={link.href}
                            className={styles.link}
                        >
                            <FormattedMessage id={link.id} />
                        </LocalizedLink>
                    </li>
                ))}
            </DynamicContainer>
        </ul>
    </div>
);

MainNavigation.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
        sectionTitle: PropTypes.string.isRequired,
        bigLink: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        list: PropTypes.string.isRequired,
        listMoreLinks: PropTypes.string.isRequired,
        column: PropTypes.string.isRequired,
        linkItem: PropTypes.string.isRequired,
        bigLinkItem: PropTypes.string.isRequired,
    }).isRequired,
    rules: PropTypes.shape({
        moreLinksInner: PropTypes.func.isRequired,
    }).isRequired,
};

export default MainNavigation;
